<template>
   <div>
      <app-header v-bind:menuList="menuList"/>
      <div class="container py-2 d-print-none" id="breadcrumbs2" style="padding-top: 0px;" v-show="homePage()">
         <nav class="breadcrumb-container d-none d-sm-block " aria-label="breadcrumb">
            <Breadcrumbs/>
         </nav>
      </div>         
      
      <fade-transition origin="center" mode="out-in" :duration="250">        
         <component :is="this.$route.meta.layout || 'div'">
            <router-view  @load="dataFetched()"/>
         </component>
      </fade-transition>

      <app-footer v-bind:menuList="menuList" v-bind:miniMenuList="miniMenuList" v-bind:cookiebar="cookiebar" v-if="footerContents">
         <template v-slot:titolo v-if="footerContents.titolo">{{footerContents.titolo.iv}}</template>
         <template v-slot:blockFirst v-if="footerContents.strutturaRiferimento" v-once >
            <div v-html="blockOne"></div>
         </template>

         <template v-slot:blockSecond v-if="footerContents.servizio">
            <div v-html="blockTwo"></div>
         </template>
      </app-footer>
      <go-top :bottom="60" :right="60" :size="60" :max-width="360" fg-color="#FFF" bg-color="#efefef" box-shadow="5px 5px 5px rgba(255, 255, 255, .1)" src="/img/backtotop.svg"></go-top>
   </div>
</template>

<script>
import AppFooter from "./AppFooter";
import AppHeader from "./AppHeader";
import GoTop from '@inotom/vue-go-top';
import { getPost, getPosts } from './../service';
import { FadeTransition } from "vue2-transitions";
import axios from 'axios';

export default {
   name: "Base",
   components: {
      AppHeader,
      FadeTransition,
      AppFooter,
      GoTop
   },   
   methods: {
      homePage() {         
         if(this.$route.path == "/" || this.$route.path == "/home" || this.$route.path == "/404" ) {
            return false
         } else {
            return true
         }
      },
      loadPost: async function(id) {
         this.footerContents = undefined;
         try {                     
            const result = await getPost(id, '');
            this.footerContents = result.items[0].data;
         } catch (ex) {
            console.log('failed loadPost');
            this.footerContents = null;
         }
      },
      mapAreeSpecializzazione(response){
         return {
            id: response.id,
            schema: response.schema,
            titolo: (response.titolo ? response.titolo : null),
            slug: (response.slug ? response.slug : null)
         };         
      },
      setArguments(){
        axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
            {
              "size": 0,
              "aggs": {
                "S3": {
                  "nested": {
                    "path": "data.s3.iv.keyword"
                  },
                  "aggs": {
                    "my-agg-name": {
                      "terms": {
                        "field": "contentId.keyword",
                        "size": 10
                      },
                      "aggs": {
                        "categories-doc": {
                          "top_hits": {
                            "_source": {
                              "includes": [
                                "data.titolo.iv.keyword"
                              ]
                            },
                            "size": 1
                          }
                        }
                      }
                    }
                  }
                },
                "Aree Specializzazione": {
                  "terms": {
                    "field": "data.areeSpecializzazione.iv.keyword",
                     "order": { "_term": "asc" }
                  }
                },
                "Argomenti": {
                  "terms": {
                    "field": "data.argomenti.iv.keyword",
                    "size" : 40,
                    "order": { "_term": "asc" }
                  }
                }
              },
              "query": {
                "match_all": {
                }
              }
            },
            {
               auth: { 
                  username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
                  password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
               }
            }
         ).then(response => {
            this.$root.setSearchArguments(response.data.aggregations.Argomenti.buckets);
         })
      }       
   },
   // Fetches posts when the component is created.
   async created() {
      try {
         this.setArguments();
         const response = await axios.get(process.env.VUE_APP_HP_LAYOUT);
         const json = await getPosts('aree-specializzazione');
         this.$root.setAreeSpeciali(json.posts.map(x => this.mapAreeSpecializzazione(x)));         
         
         this.menuRoutes = response.data[0].menuList[0].menuItemList;
         this.menuList = response.data[0].menuList[0].menuItemList;
         this.miniMenuList = response.data[0].menuList[2].menuItemList,    
         this.cookiebar = this.miniMenuList[this.miniMenuList.length-1],
         this.miniMenuList = this.miniMenuList.splice(0,this.miniMenuList.length-1),
         this.loadPost(response.data[0].menuList[1].menuItemList[1].idFonteDati);
         //this.$root.setMainMenu(this.menuList);
         this.$root.setHPLayout(response.data[0].bloccoPaginaList); 
         this.$root.setS3Categories(this.menuList[0].menuItemList);
      } catch (e) {
         this.errors.push(e)
      }
      this.argomenti = this.$root.argomenti;      
   },
   data() {
      return {
         layout : {},
         errors: [],
         menuList: [],// this.layout.menuList[0].menuItemList,
         footerContents: null, // this.layout.menuList[1],
         miniMenuList: [], //this.layout.menuList[2].menuItemList,    
         cookiebar: []              
      };
   },
   computed: {
      blockOne: function () {
         return this.footerContents.strutturaRiferimento.iv[0].personaRiferimento + '<br>' 
         + this.footerContents.strutturaRiferimento.iv[0].indirizzo + '<br>'          
         + (this.footerContents.strutturaRiferimento.iv[0].telefono != null ? 'Telefono <a class="text-white" href="tel:'+this.footerContents.strutturaRiferimento.iv[0].telefono+'" '+this.footerContents.strutturaRiferimento.iv[0].telefono+'">' + '' +this.footerContents.strutturaRiferimento.iv[0].telefono + '</a>' : '')
         + (this.footerContents.strutturaRiferimento.iv[0].fax != null ? " - Fax " + this.footerContents.strutturaRiferimento.iv[0].fax + '<br>' : '') 
         + 'Email <a class="text-white" href="mailto:'+this.footerContents.strutturaRiferimento.iv[0].email+'" title="email '+this.footerContents.strutturaRiferimento.iv[0].email+'">' + this.footerContents.strutturaRiferimento.iv[0].email + '</a>';
      },
      blockTwo: function () {
        return this.footerContents.servizio.iv[0].personaRiferimento + '<br>' 
         + this.footerContents.servizio.iv[0].indirizzo + '<br>' 
         + (this.footerContents.servizio.iv[0].telefono != null ? "Telefono " + this.footerContents.servizio.iv[0].telefono + '<br>' : '')
         + (this.footerContents.servizio.iv[0].fax != null ? "Fax " + this.footerContents.servizio.iv[0].fax + '<br>' : '') 
         + 'Email <a class="text-white" href="mailto:'+this.footerContents.servizio.iv[0].email+'" title="email '+this.footerContents.servizio.iv[0].email+'">' + this.footerContents.servizio.iv[0].email + '</a>';
      },

   }   
};
</script>
<style>
.breadcrumb{
   margin-bottom: 0.5rem;
   margin-top: 0.5rem;
}

</style>